import { render, staticRenderFns } from "./electricBoard.vue?vue&type=template&id=22bc19e1&scoped=true"
import script from "./electricBoard.vue?vue&type=script&lang=js"
export * from "./electricBoard.vue?vue&type=script&lang=js"
import style0 from "./electricBoard.vue?vue&type=style&index=0&id=22bc19e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bc19e1",
  null
  
)

export default component.exports